
const SocialFeed = (element) => {
  const main = () => {
    // console.log("SocialFeed");
  }

  main();
};

export default SocialFeed;
